import React from 'react'

const Menu = () => {

    return (
        <nav className="navbar">
            <ul>
                <li>
                    <a href="#about">O mnie</a>
                </li>
                <li>
                    <a href="#works">Portfolio</a>
                </li>
                <li>
                    <a href="#contact">Kontakt</a>
                </li>
            </ul>
        </nav>
    );
}

export default Menu
